import axios from "axios";
import qs from "qs";

const hostname = process.env.VUE_APP_API_HOST;
const protocol = process.env.VUE_APP_API_PROTOCOL;

export const api = {
  getTotalCount() {
    return axios({
      method: "get",
      url: `${protocol}${hostname}/brands/count`,
    });
  },

  getSearchResult(searchQuery, limit, offset) {
    return axios({
      method: "get",
      url: `${protocol}${hostname}/brands?search=${searchQuery}&limit=${limit}&offset=${offset}`,
    });
  },

  getMostRecentBrands(count, onlyWithLogo = false) {
    const url = `${protocol}${hostname}/brands/mostrecent?count=${count}${onlyWithLogo ? `&onlywithlogo=${onlyWithLogo}` : ""
      }`;

    return axios({ method: "get", url });
  },

  //+admin stuff
  loginAdmin(email, password) {
    return axios({
      method: "post",
      url: `${protocol}${hostname}/adminBrands/checklogin`,
      params: {
        email,
        password
      }
    });
  },

  tokenAdmin(token) {
    return axios({
      method: "post",
      url: `${protocol}${hostname}/adminBrands/checktoken`,
      params: {
        token
      }
    });
  },

  getAdminBrands(limit, offset, dlc, search) {
    return axios({
      headers: { "authorization": "bearer " + localStorage.getItem('token') },
      method: "get",
      url: `${protocol}${hostname}/adminBrands`,
      params: {
        limit,
        offset,
        dlc,
        search
      },
      paramsSerializer: params => {
        return qs.stringify(params, { indices: false });
      }
    });
  },

  getAdminDetails(id) {
    return axios({
      headers: { "authorization": "bearer " + localStorage.getItem('token') },
      method: "get",
      url: `${protocol}${hostname}/adminBrands/${id}`
    });
  },

  saveAdminInfo(data) {
    return axios({
      headers: { "authorization": "bearer " + localStorage.getItem('token') },
      method: "post",
      url: `${protocol}${hostname}/adminBrands/savedetails`,
      data,
    });
  },

  deleteBrand(brandId) {
    return axios({
      headers: { "authorization": "bearer " + localStorage.getItem('token') },
      method: "post",
      url: `${protocol}${hostname}/adminBrands/deletebrand`,
      params: {
        brandId
      }
    });
  },

  getRequestData(id) {
    return axios({
      headers: { "authorization": "bearer " + localStorage.getItem('token') },
      method: "get",
      url: `${protocol}${hostname}/adminBrands/getrequest?requestID=${id}`,
    });
  },
  //-admin stuff

  getFilteredBrands(filter) {
    return axios({
      method: "get",
      url: `${protocol}${hostname}/brands?filter=${filter}`,
    });
  },

  getBrandDetails(gbin) {
    return axios({
      method: "get",
      url: `${protocol}${hostname}/brands/${gbin}`,
    });
  },

  getBrandIndex() {
    return axios({
      method: "get",
      url: `${protocol}${hostname}/brands/filters`,
    });
  },

  getIndustries() {
    return axios({
      method: "get",
      url: `${protocol}${hostname}/industries`,
    });
  },

  getCountries() {
    return axios({
      method: "get",
      url: `${protocol}${hostname}/countries`,
    });
  },

  saveForm(type, data) {
    return axios({
      method: "post",
      url: `${protocol}${hostname}/${type}`,
      data,
    });
  },
};
